import { useContext } from 'react';
import { BrowserContext } from '@invitae/nucleobase-core';

/**
 * Hook that provides functions involving browser
 * @returns object
 */
var useBrowserActions = function () {
    var browserActions = useContext(BrowserContext).browserActions;
    var getPath = function () {
        var _a;
        return ((_a = browserActions === null || browserActions === void 0 ? void 0 : browserActions.getPath) === null || _a === void 0 ? void 0 : _a.call(browserActions)) || window.location.pathname;
    };
    var push = function (url) {
        if (browserActions === null || browserActions === void 0 ? void 0 : browserActions.push) {
            browserActions.push(url);
            return;
        }
        window.location.href = url;
    };
    var replace = function (url) {
        if (browserActions === null || browserActions === void 0 ? void 0 : browserActions.replace) {
            browserActions.replace(url);
            return;
        }
        window.location.replace(url);
    };
    return {
        getPath: getPath,
        push: push,
        replace: replace,
    };
};

export { useBrowserActions };
//# sourceMappingURL=useBrowserActions.esm.js.map
